import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getGiftingModule } from './module';

export interface Props {}

const ModuleLoader: React.FC<Props> = () => {
  return <DynamicModuleLoader modules={[getGiftingModule()]} />;
};
ModuleLoader.displayName = 'ModuleLoader';

export default ModuleLoader;
